import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import DraggableItem from './DraggableItem';
import Editor from './Editor';
import './app.css';
import { useSelector } from "react-redux";

import API from "../../ApiConfig"
import { BASE_URL, GET_LAYOUT, USER_TOKEN, TAGS_BY_ISSUER, VALIDATE_DOCUMENT, SET_LAYOUT, SET_DOCUMENT_ACTIVE, UPDATE_DOCUMENT_NAME, localDataKeys, SET_AND_ACTIVATE_LAYOUT, DELETE_PAGE, COPY_TO_MASTER_DOCUMENT, CONVERT_DOCUMENT_BACKGROUND } from '../../Utils/constant';
import { MESSAGE, BUTTONS, LAYOUT_TEXT } from '../../Utils/Strings';
import styles from "./layout.module.css";
import HeaderStyle from "../../pages/DashBoard/CreateDocument.module.css"

import cogoToast from 'cogo-toast-react-17-fix';
import { useNavigate } from 'react-router-dom';
import AutoRefreshToken from '../../Hooks/useAutoRefreshToken';
import Loader from '../Loader';
import Icon from 'react-icons-kit';
import { chevronLeft } from 'react-icons-kit/ionicons/chevronLeft'
import { chevronRight } from 'react-icons-kit/ionicons/chevronRight'
import { androidCancel } from 'react-icons-kit/ionicons/androidCancel'
import { androidDocument } from 'react-icons-kit/ionicons/androidDocument'
import { androidCloudDone } from 'react-icons-kit/ionicons/androidCloudDone'
import { androidDelete } from 'react-icons-kit/ionicons/androidDelete'

import useNavigationBlocker from '../../Hooks/useSaveDraft';
import useRefreshToken from '../../Hooks/usegenerateToken';
import { _ToNormal, setDate, stringFormatter } from '../../Utils/helper';
import Breadcrumb from '../Verifier/breadcrumb/BreadCrumb';
import IssuerNavigator from '../DashBoard/IssuerNavigator';

const LayoutDocument = ({ id }) => {
  AutoRefreshToken(BASE_URL + USER_TOKEN)
  useRefreshToken(BASE_URL + USER_TOKEN)

  const navigate = useNavigate()

  // to get user Type
  const User = useSelector(state => state.User)



  var contentType = ["Heading", "Address", "Icon", "content", "Signature", "Text","QR"]

  const parentRef = useRef(null);
  const sendPdf = useRef(null)
  const editorRef = useRef(null);

  const [loading, setLoading] = useState(true) // no longer using, remove this
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [buttonLoading, setbuttonLoading] = useState(0);
  const [saved, setsaved] = useState(false)

  //Pagination Data
  const [page, setPage] = useState(1)
  const [pageData, setPageData] = useState(JSON.parse(localStorage.getItem(localDataKeys.DOCUMENT_DRAFT)) || [{ layout: '[]' }])
  // const [pageData, setPageData] = useState({})
  const [totalPage, setTotalPage] = useState(pageData?.page_layout?.length || 1)

  // Main content
  const [companylogo, setCompanyLogo] = useState('')
  const [layout, setLayout] = useState()
  const [Address, setAddress] = useState('')
  const [items, setItems] = useState([]);
  // const [items, setItems] = useState(JSON.parse(pageData[0]?.layout));
  const [content, setContent] = useState("Insert Text...")
  const [issuer_id, setIssuerId] = useState(0)
  const [background, setBackground] = useState({ url: '', file: '', opacity: 1 });
  const [Sign, setSign] = useState({ url: '', file: '' })
  const [docName, setdocname] = useState('');
  const [edit, setEdit] = useState(false)

  // Tags and Content Data
  const [selectedTags, setSelectedTags] = useState({})
  const [tagsDropDown, setTagsDropDown] = useState(false)
  const [TagItems, setTagItems] = useState(useSelector(store => store.Tags.items))
  const [searchTagList, setSearchTagList] = useState(TagItems)
  // const [text, setText] = useState('')
  // const [textLen, setTextLen] = useState(1250 - text.length)
  const [search, setSearch] = useState('')
  const [qrCode, setQrCode] = useState('/QR.png')

  const [isBackgroundRemoved, setIsBackgroundRemoved]=useState(false)

  // Page Navigation Functions
  const setPageLayout = (page) => {
    let pageData = JSON.parse(localStorage.getItem(localDataKeys.DOCUMENT_DRAFT))
    setLayout(JSON.parse(pageData.page_layout[page - 1].layout))
    setContent(pageData.page_layout[page - 1].template_content)
    setBackground({ url: pageData.page_layout[page - 1].background, file: '', opacity: pageData.page_layout[page - 1].opacity })
    setSign({ url: pageData.page_layout[page - 1].signature, file: '' })

    let pageTags = JSON.parse(localStorage.getItem(localDataKeys.TAGS_DRAFT))[page - 1] || []
    setSelectedTags(pageTags)
  }

  const setCurrentPage = (value) => {

    if (value > 0 && value <= totalPage) {
      if (localStorage.getItem(localDataKeys.FILE_DRAFT) == 0) {
        cogoToast.info("Please save document before moving to next page")
      }
      else {
        setPage(value)
        setPageLayout(value)
      }
    }
  }

  const addNewPage = () => {
    if (totalPage < 10) {
      setTotalPage(totalPage + 1)
      setPage(totalPage + 1)
      let data = JSON.parse(localStorage.getItem(localDataKeys.DOCUMENT_DRAFT))
      let temp = data.page_layout
      temp.push({
        "doc_id": id,
        "page_number": totalPage + 1,
        "title": "Title",
        "template_content": "<p>New Text...</p>",
        "background": null,
        "signature": null,
        "opacity": 1,
        "layout": `[{\"id\":${Date.now()},\"left\":40,\"top\":100,\"name\":\"content\",\"width\":300,\"height\":100}]`,
        "html_content": null
      })
      data['page_layout'] = temp
      localStorage.setItem(localDataKeys.DOCUMENT_DRAFT, JSON.stringify(data))
      setPageLayout(totalPage + 1)
      setPageData(data)
    }
    else {
      cogoToast.info(MESSAGE.MAX_PAGE_REACHED)
    }
  }

  const removePage = () => {
    const removeFromLocal = () => {
      setTotalPage(totalPage - 1)
      setPage(totalPage - 1)
      let data = JSON.parse(localStorage.getItem(localDataKeys.DOCUMENT_DRAFT))
      let temp = data.page_layout.filter((item, index) => index != page - 1)

      temp = temp.map((item, index) => {
        item.page_number = index + 1;
        return item;
      });

      data['page_layout'] = temp
      localStorage.setItem(localDataKeys.DOCUMENT_DRAFT, JSON.stringify(data))
      setPageLayout(totalPage - 1)
      setPageData(data)
      let tagData = JSON.parse(localStorage.getItem(localDataKeys.TAGS_DRAFT))
      tagData.splice(page - 1, 1)
      localStorage.setItem(localDataKeys.TAGS_DRAFT, JSON.stringify(tagData))
      cogoToast.info(`Page ${page} deleted`)
    }
    const delete_page = (page) => {
      setTimeout(() => {
        API.delete(DELETE_PAGE + id + "/" + page).then(res => {
          if (res.data.message == "Success")
            removeFromLocal()
        }).catch(err => {
          // console.log(err)
          if (err.request.status == 333)
            removeFromLocal()
          else
            cogoToast.error("Unable to delete page")
        })
      }, 1000);
    }

    const PopUp = () => {
      return (
        <div>Delete Page</div>
      )
    }
    if (totalPage > 1) {
      const { hide } = cogoToast.error(<div>
        <button className='btn btn-primary fnt-12' onClick={() => delete_page(page)}>Delete</button>
        <button className='btn btn-secondary ml-4 fnt-12'>Don't Delete</button>
      </div>, {
        hideAfter: 5,
        heading: "Confirm Page delete, it will remove the page and it's content",
        onClick: () => { hide() }
      })

      // <ReactPortalModal title={'Confirm Delete'} isOpen={true} onClose={false} blockOutsideClick={true}>
      //   <PopUp />
      // </ReactPortalModal>
    }
    else {
      cogoToast.info(MESSAGE.MIN_PAGE_REACHED)
    }
  }


  const navigateOut = (link) => {
    let saved = localStorage.getItem(localDataKeys.SAVED)
    if (saved == 'true') {
      navigate(link)
    }
    else {
      cogoToast.info(MESSAGE.SAVED_LOCALLY)
    }
  }

  // Layout and editing Functions

  const setTagsfromRequest = (tags) => {
    const filledTagsList = [];
    for (const page in tags) {
      const filledTags = tags[page].filled_tag;
      const pageObject = {};
      filledTags.forEach(([tag, count]) => {
        pageObject[tag] = count;
      });
      filledTagsList.push(pageObject);
    }
    if (filledTagsList.length == 0)
      filledTagsList.push({})
    localStorage.setItem(localDataKeys.TAGS_DRAFT, JSON.stringify(filledTagsList))
    return filledTagsList;
  }

  const getLayout = async () => {
    try {
      const response = await API.get(GET_LAYOUT + id);
      const res = response.data.data;
      const document_data = {}
      if (response.data.success) {
        setLayout(JSON.parse(res.document_layout[page - 1].layout));
        document_data['page_layout'] = res.document_layout
        setTotalPage(res.document_layout.length)
        setPageData(res.document_layout)
        setSelectedTags(setTagsfromRequest(res.document.tag_layout)[0])

        const logoPath = res.issuer?.logo_path;
        if (logoPath) {
          setCompanyLogo(logoPath);
          document_data['companylogo'] = logoPath;
        }
        if (res.issuer?.address1){
          const address1 = res.issuer?.address1 || "";
          const address2 = res.issuer?.address2 || "";

          const fullAddress = [address1, address2]
            .filter(Boolean)
            .join("<br> ");

          setAddress(fullAddress);
        document_data['Address'] = fullAddress;
        }
        setdocname(res.document?.doc_name || '');
        document_data['docName'] = res.document?.doc_name;

        const backgroundPath = res.document_layout[page - 1].background;
        if (backgroundPath) {
          setBackground(prev => ({
            ...prev,
            url: backgroundPath,
            opacity: res.document_layout[page - 1].opacity
          }));

        }

        const signaturePath = res.document_layout[page - 1]?.signature;
        if (signaturePath) {
          setSign(prev => ({
            ...prev,
            url: signaturePath,
            file: null
          }));
        }

        const templateContent = res.document_layout[page - 1]?.template_content;
        if (templateContent) {
          setContent(templateContent);
        }
        setIssuerId(res.issuer.id);
        document_data['issuer_id'] = res.issuer.id;

        localStorage.setItem(localDataKeys.DOCUMENT_DRAFT, JSON.stringify(document_data))
        // localStorage.setItem(localDataKeys.TAGS_DRAFT, '[{}]')
        localStorage.setItem(localDataKeys.LAST_SAVE, setDate(res.document.updated_at))

      } else {
        setLoading(false);
      }
    } catch (response) {
      // console.log(response)
      // cogoToast.error(error.response)
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getLayout();
    };
    let document = JSON.parse(localStorage.getItem(localDataKeys.DOCUMENT_DRAFT))


    if (document && document?.page_layout[0].doc_id == id) {
      setSelectedTags(JSON.parse(localStorage.getItem(localDataKeys.TAGS_DRAFT))[page - 1])

      setLayout(JSON.parse(document.page_layout[page - 1].layout))

      const logoPath = document.companylogo
      if (logoPath) {
        setCompanyLogo(logoPath);
      }
      if (document.Address)
        setAddress(document.Address.split("_").join("<br> "))
      setdocname(document.docName || '');

      const backgroundPath = document.page_layout[page - 1].background
      if (backgroundPath) {
        setBackground(prev => ({
          ...prev,
          url: backgroundPath,
          opacity: document.page_layout[page - 1].opacity
        }));
      }

      const signaturePath = document.page_layout[0].signature
      if (signaturePath) {
        setSign(prev => ({
          ...prev,
          url: signaturePath,
          file: null
        }));
      }

      const templateContent = document.page_layout[0].template_content
      if (templateContent) {
        setContent(templateContent);
      }
      setIssuerId(document.issuer_id);
    }
    else {
      fetchData();
    }

    API.get(TAGS_BY_ISSUER + id)
      .then(data => {
        let res = data.data
        if (res.success == true) {
          setTagItems(res.data)
          setSearchTagList(res.data)
        }
        setLoading(false)
      });
  }, []);

  const getDocumentLayout = async (layoutData) => {
    try {
      const updatedLayout = layoutData.map(item => {
        switch (item.name) {
          case contentType[0]:
            return { ...item, content: docName };
          case contentType[1]:
            return { ...item, content: Address };
          case contentType[2]:
            return { ...item, content: `<img src='${companylogo}'>` };
          case contentType[3]:
            return { ...item, content: content || "Insert Text..." };
          case contentType[4]:
            if (Sign.url !== '') {
              return { ...item, content: `<img src='${Sign.url}'>` };
            }
          case contentType[6]:
              return { ...item, content: `<img src='${qrCode}'>` }
          default:
            return item;
        }
      });
      setItems(updatedLayout);
      setLoading(false)
    } catch (error) {
      cogoToast.error(error.message);
    }
  };

  useEffect(() => {
    const fetchAdditionalData = async () => {
      if (layout) {
        await getDocumentLayout(layout);
        setLoading(false);
      }
    };
    fetchAdditionalData();
  }, [layout]);


  const handleOpacity = (opacity) => {
    setBackground(prev => ({ ...prev, opacity }));
  }

 

  function dataUrlToFile(dataUrl, filename) {
    const [header, base64] = dataUrl.split(",");

    const mime = header.match(/:(.*?);/)[1];

    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return new File([bytes], filename, {
        type: mime
    });
}
  
  const getImgfromPdf = async (file) => {
    const formData = new FormData();
  
    formData.append("file", file);
  
    setLoading(true);
  
    try {
      const res = await API.post(CONVERT_DOCUMENT_BACKGROUND, formData);
  
      if (res.data.status === 200) {
  
        const imageUrl = res.data.data.image_base64;
  
        // Convert Base64 → File
        const convertedFile = await dataUrlToFile(
          imageUrl,
          file.name
        );
  
        // Set converted image file, NOT original PDF
        setBackground(prev => ({
          ...prev,
          url: imageUrl,
          file: convertedFile
        }));
      }
  
    } catch (err) {
  
      cogoToast.error(
        err?.response?.data?.message || "PDF conversion failed"
      );
  
    } finally {
      setLoading(false);
    }
  };
  const handleImageUpload = (event, type) => {

    setIsBackgroundRemoved(false)
    // console.log(type)
    const file = event.target.files[0];
    
    if (file) {
      const url = URL.createObjectURL(file);
      if (type == 0){
        const allowedTypes=[
          "image/jpeg",
          "image/png",
          "image/jpg"
        ]
        if(allowedTypes.includes(file.type)){
          setBackground(prev => ({ ...prev, url, file }))
        }
        else if(file.type=="application/pdf"){
          getImgfromPdf(file)
        }
        else{
          cogoToast.error("Only PDF, jpg, jpeg, png are allowed")
        }
      }
      else{
        setSign(prev => ({ ...prev, url, file }))
      localStorage.setItem(localDataKeys.FILE_DRAFT, 0)
      }
    }
  };

  const addItem = (content_type) => {
    if (
      content_type === 4 &&
      items.some((item) => item.name === contentType[6])
      && User?.qr_enabled
    ) {
      alert(MESSAGE.QR_LENGTH_REACHED);
      return;
    }
    if (items.length >= 10) {
      alert(MESSAGE.MAX_VALUE_REACHED);
      return;
    }
    let content = 'Insert Text'
    let name = contentType[5]
    let width=100
    let height=100
    switch (content_type) {
      case 1:
        content = `<p><img src='${companylogo}'></p>`;
        name = contentType[2]
        break;
      case 2:
        content = `<p>"${Address}"</p>`;
        name = contentType[1]
        break
      case 3:
        content = `<p><img src='${Sign.url}'></p>`;
        name = contentType[4]
        break;
      case 4:
        content = `<p><img src='${qrCode}'></p>`;
        name = contentType[6]
        width=85
        height=85
        break
      default:
        content = 'Insert Text';
        break;
    }
    const lastID = items.reduce((maxId, item) => Math.max(item.id, maxId), 0);
    const newItem = { id: lastID + 1, left: 60, top: 60, content, name, width: 100, height: 100 };
    setItems([...items, newItem]);
    setSelectedItemId(newItem.id);
  };

  const updatePosition = (id, newProps) => {
    setItems(items.map(item => item.id === id ? { ...item, ...newProps } : item));
  };

  const removeItem = (id) => {
    setItems(items.filter(item => item.id !== id));
    const lastID = items.reduce((maxId, item) => Math.max(item.id, maxId), 0);
    setSelectedItemId(lastID);
  };

  const copytodoc = () => {
    API.get(COPY_TO_MASTER_DOCUMENT + id)
      .then(res => {
        if (res.status === 200) {
          navigate(`/templates`)
        }
      })
      .catch(err => {
        setLoading(false)
        cogoToast.error(err.message)
      })
  }


  const submitDesign = (saveandcontinue) => {
    localStorage.setItem(localDataKeys.FILE_DRAFT, 1);
    localStorage.setItem(localDataKeys.SAVED, true);
    const URL = saveandcontinue ? SET_AND_ACTIVATE_LAYOUT : SET_LAYOUT
    setSelectedItemId(null)
    setTagsDropDown(false)
    const layout = items.map(item => {
      if (item.name !== contentType[5]) {
        const { content, ...rest } = item;
        return rest;
      }
      return item;
    });

    const formData = new FormData();
    formData.append('doc_id', id)
    formData.append('page_number', page)
    formData.append('opacity', background.opacity)
    formData.append('title', "Title")
    formData.append('template_content', items.filter(item => item.name === contentType[3]).map(item => item.content).join(''))
    formData.append('layout', JSON.stringify(layout))
    formData.append('html_content', sendPdf.current.innerHTML)
    formData.append("background_removed", isBackgroundRemoved)
    if (background.file != null)
      formData.append('background_file', background.file)
    if (Sign.file != null) {
      formData.append('signature_file', Sign.file);
    }

    if (saveandcontinue) {
      setbuttonLoading(2)
    }
    else {
      setbuttonLoading(1)
    }
    API.post(URL, formData)
      .then(data => {
        let res = data.data
        if (res.success == true) {
          cogoToast.success(MESSAGE.SAVED)
          let currentDate = setDate(Date.now())
          localStorage.setItem(localDataKeys.LAST_SAVE, currentDate)
          if (saveandcontinue) {
            setTimeout(() => {
              setLoading(false);
              if (User.user_type === "internal_user" ||  User.user_type==="Super Admin") {
                // debugger
                if (issuer_id == 2) {
                  copytodoc()
                }
                else {
                  navigate(`/company/1/${issuer_id}/Documents/`)

                }
              }
              else
                navigate('/dashboard/mydocuments')

            }, 1000)
          }
        }
        else {
          cogoToast.error(res.message, { position: 'top-right' })
          setLoading(false);
        }
        if (!saveandcontinue) {
          setLoading(false)
          setbuttonLoading(0)
        }
        else {
          //   API.get(SET_DOCUMENT_ACTIVE + id).then(data => {
          //     let res = data.data
          //     if (res.success == true) {
          //       console.log(`State Updated for ${id} to ${res.data}`)
          //     }
          //   })
          //     .catch(err => {
          //       // if (err?.response?.data?.detail[0])
          //       //   cogoToast.error(err.response.data.detail[0])
          //       // else
          //       cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
          setLoading(false)
          //     }
          //     )
        }
      })
      .catch(err => {
        if (err.response.data.detail[0]) {
          let tag_left = err.response.data.detail[0].overall_tags.tag_left
          let invalid_tag = err.response.data.detail[0].page_wise.invalid_tag
          let invalidTagString = Object.entries(invalid_tag)
            .map(([key, value]) => `"${key.replace(/[{}]/g, '')}" at ${value}`)
            .join(', ');
          if (invalidTagString.length > 0) {
            cogoToast.error(stringFormatter(MESSAGE.INVALID_TAG, [invalidTagString]))
          }
          if (tag_left && tag_left.length > 0 && invalidTagString.length < 1)
            cogoToast.error(stringFormatter(MESSAGE.TAG_LEFT, [tag_left]))
        }
        else {
          cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)

        }
        setbuttonLoading(0)
        setLoading(false)
      }
      )
  };

  useNavigationBlocker(id, docName, content, items, Sign, background, issuer_id, companylogo, Address, page)
  const selectedItem = items.find(item => item.id === selectedItemId) || { id: null, name: null };
  const trayRef = useRef(null);

  // Tags and search
  const SearchTags = (search) => {
    setSearch(search)
    let newArr = TagItems.filter(e => e.field_name.includes(search))
    setSearchTagList(newArr)
  }

  const resetSearch = () => {
    setSearch('')
    setSearchTagList(TagItems)
  }

  const validate = (e) => {
    e.preventDefault();
    setLoading(true)
    setbuttonLoading(3)
    let content = items.map(item => {
      if (item.name == contentType[5] || item.name == contentType[3]) {
        return item.content;
      }
    });
    // console.log(content)
    API.post(`${VALIDATE_DOCUMENT}?document_id=${id}`, {
      // "document_id": parseInt(id),
      // "content": content.toString()
    })
      .then(data => {
        cogoToast.success(MESSAGE.VALIDATED)
      }).catch(err => {
        // cogoToast.error(err.response.data.message)
        let invalidTagString = Object.entries(err.response.data.detail[0].invalid_tag)
          .map(([key, value]) => `{${key.replace(/[{}]/g, '')}} at ${value}`)
          .join(', ');
        // console.log(invalidTagString)
        cogoToast.error(stringFormatter(MESSAGE.INVALID_TAG, [invalidTagString]))
      })
      .finally(() => {
        setLoading(false)
        setbuttonLoading(0)
      }
      )
  }

  const AddselectedTags = useCallback((id, name) => {
    setSelectedTags(selectedTags => [...selectedTags, id])
    let newcontent = selectedItem.content + " " + name
    updatePosition(selectedItem.id, { content: newcontent });
  }, [selectedItem]);

  const RemoveSelectedTags = useCallback((id, name) => {
    // setSelectedTags(selectedTags.filter((i) => i != name))
    const regex = new RegExp(name, "g");
    const matches = editorRef.current.value.match(regex);
    // console.log(matches)
    if (matches && matches.length > 0) {
      setSelectedTags((prevSelectedTags) => {


        const currentCount = prevSelectedTags[name];
        if (currentCount === 1) {
          const { [name]: _, ...rest } = prevSelectedTags;
          return rest;
        }
        return {
          ...prevSelectedTags,
          [name]: currentCount - 1,
        };
      });
      // let newcontent = selectedItem.content.replace(new RegExp(name, "g"), "")
      let newcontent = selectedItem.content.replace(new RegExp(name + '(?!.*' + name + ')'), '');
      updatePosition(selectedItem.id, { content: newcontent });
      let tags = JSON.parse(localStorage.getItem(localDataKeys.TAGS_DRAFT)) || [];
      tags[page - 1] = { ...tags[page - 1], [name]: undefined }; // Remove tag from current page
      localStorage.setItem(localDataKeys.TAGS_DRAFT, JSON.stringify(tags));
    }
  }, [selectedItem]);

  // const RemoveUnusedTags = () => {
  //   debugger
  //   let selected = {}
  //   let content = items.map(item => {
  //     if (item.name == contentType[5] || item.name == contentType[3]) {
  //       return item.content;
  //     }
  //   }).join("**");
  //   TagItems.map(tag => {
  //     let tagCount = (content.match(new RegExp(tag.html_tag, "g")) || []).length;
  //     selected[tag.html_tag] = tagCount;
  //   })
  //   setSelectedTags(selected)
  // }

  // useEffect(() => {
  //   RemoveUnusedTags()
  // }, [items])

  // DRAG AND DROP TAGS
  const handleDragStart = (event, text) => {
    event.dataTransfer.setData('text/plain', text);
  };

  const handleDrop = (event, id) => {
    const boundingBox = document.querySelector('.jodit-wysiwyg').getBoundingClientRect()
    // console.log(boundingBox, event.clientX, event.clientY)
    if (event.clientX >= boundingBox.left && event.clientX <= boundingBox.right && event.clientY >= boundingBox.top && event.clientY <= boundingBox.bottom)
      setSelectedTags((prevSelectedTags) => {
        const currentCount = prevSelectedTags[id] || 0;
        const updatedTags = {
          ...prevSelectedTags,
          [id]: currentCount + 1
        };
        let tags = JSON.parse(localStorage.getItem(localDataKeys.TAGS_DRAFT)) || [];
        tags[page - 1] = updatedTags;
        localStorage.setItem(localDataKeys.TAGS_DRAFT, JSON.stringify(tags));
        return updatedTags;
      });
  };

  // Additional Code
  const DropDown = () => {
    return (
      <div className={styles.DropDown}>
        <span className={styles.DropDownHeading}>Insert Tags</span>
        <div className={styles.searchbox}>
          <img src='/searchoutline.svg' />
          <input className={styles.searchinput} value={search} onChange={(e) => SearchTags(e.target.value)} />
          {search ? <img src='/x.svg' onClick={resetSearch} className={styles.closeSearch} /> : <></>}
        </div>
        <div className={styles.taglist}>
          {/* {searchTagList.map((i) => (
            selectedTags.includes(i.field_id) ?
              <div className={styles.listelements + " " + styles.selectedList} key={i.id} onClick={(e) => RemoveSelectedTags(i.field_id, i.html_tag)}><img src='/Tick.svg' />{i.field_name}</div> :
              <div className={styles.listelements} key={i.id} onClick={(e) => AddselectedTags(i.field_id, i.html_tag)}>{i.field_name}</div>)
          )} */}
          {/* {
            searchTagList.map((i) => (
              <div
                className={styles.listelements}
                key={i.id}
                draggable='true'
                id='draggable-tags'
                onDragStart={(event) => handleDragStart(event, i.html_tag)}
                onDragEnd={(event) => handleDrop(event, i.html_tag)}
              >
                {selectedTags.includes(i.html_tag) ? <Icon icon={androidCancel}
                  onClick={() => RemoveSelectedTags(i.field_id, i.html_tag)} style={{ cursor: 'pointer' }}
                /> : null} {_ToNormal(i.field_name)}
                <span className={styles.counter}>{i.field_id}</span></div>
            ))
          } */}

          {
            searchTagList.map((i) => (
              !i.hide_in_pdf&&
              <div
                className={styles.listelements}
                key={i.id}
                draggable='true'
                id='draggable-tags'
                onDragStart={(event) => handleDragStart(event, i.html_tag)}
                onDragEnd={(event) => handleDrop(event, i.html_tag)}
              >
                {selectedTags[i.html_tag] ? <Icon icon={androidCancel}
                  onClick={() => RemoveSelectedTags(i.field_id, i.html_tag)} style={{ cursor: 'pointer' }}
                /> : null} {_ToNormal(i.field_name)}
                <span className={styles.counter}>{selectedTags[i.html_tag] ? selectedTags[i.html_tag] : 0}</span>
              </div>
            ))
          }
        </div>
      </div>
    )
  }

  const Header = () => {
    const document_name = useRef(null);

    return (
      <div className={HeaderStyle.h1} style={{ justifyContent: "space-between" }}>
        {/* <div>
          {
            edit ?
              <div className={styles.Actions}>
                <input
                  type="text"
                  ref={document_name}
                  defaultValue={docName}
                  className={styles.inputbox}
                  placeholder="Document Title"
                  maxLength='100'
                  minLength='1'
                />
                <button onClick={(e) => { e.preventDefault(); handleDocNameChange(document_name.current.value) }} className={styles.button}>{BUTTONS.SAVE_DOCUMENT_NAME}</button>
                <button onClick={(e) => { e.preventDefault(); setEdit(false) }} className={[styles.button, styles.white].join(" ")}>{BUTTONS.CANCEL}</button>
              </div> :
              <div className={styles.Actions}>
                <h2 className={HeaderStyle.input}>{docName}</h2>
                <img src="/editnew.svg" onClick={() => (setEdit(true))} />
              </div>
          }
        </div> */}
        <div className={styles.buttonBase} style={{ width: '20rem' }}>
          {/* <div className={styles.buttonBase3}>
            <div className={styles.text11}>Last Saved on {localStorage.getItem(localDataKeys.LAST_SAVE)}</div>
          </div> */}
          <div className={styles.button + " " + styles.white} onClick={() => submitDesign(false)}>

            <div className={styles.buttonBase3}>
              <div className={styles.text11}>{buttonLoading === 1 ? BUTTONS.SAVING : BUTTONS.SAVE_DRAFT}</div>
            </div>
          </div>
          <div className={styles.button} onClick={() => submitDesign(true)}>
            <div className={styles.buttonBase3}>
              <div className={styles.text11}>{buttonLoading === 2 ? BUTTONS.SAVING : BUTTONS.SAVE_AND_CONTINUE}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // const scrollTray = (direction) => {
  //   const tray = trayRef.current;
  //   const scrollAmount = 500; // Adjust scroll amount as needed

  //   if (direction === 'left') {
  //     tray.scrollLeft -= scrollAmount;
  //   } else {
  //     tray.scrollLeft += scrollAmount;
  //   }
  // };

  const handleButton=()=>{
    submitDesign(false)
    navigate("/Create/" + id + "/Mapping")
    
  }
  return (
    <>
      <Breadcrumb title={"Create New Template"} pos={3} category={"template"} />
      <IssuerNavigator title="Design Template"
      //  step={"/Create/" + id + "/Mapping"}
        actions={Header} onBack={handleButton} />
      <Loader isOpen={loading} />
      <div className={styles.layoutShell + " issuer-container"}>
        <div className={styles.backgroundCard + " " + styles.elementsBar}>
          <h2 className='header-title' style={{ fontSize: '1rem', margin: '1rem 0', fontWeight: '600' }}>Add Elements</h2>
          <div>
            {/* <button className={styles.scrollButton} onClick={() => scrollTray('left')}><Icon icon={chevronLeft} size={20} /></button> */}

            <div className={styles.ElementBase} ref={trayRef}>
              <div className={styles.card}>
                <span className={styles.description}>Add a blank text Element</span>
                <button className={styles.button + " " + styles.white} onClick={() => addItem(0)}>{LAYOUT_TEXT.ADD_TO_DESIGN}</button>
              </div>
              <div className={styles.card}>
                {
                  companylogo ?
                    <>
                      {/* <div className={styles.Elementactions}>
                      <div>
                        <button className={styles.button} onClick={() => navigateOut(`/company/1/${issuer_id}/profile`)}>+ Update Logo</button>
                      </div>
                    </div> */}
                      <div className={styles.description}>
                        <img src={companylogo} className={styles.image} />
                      </div>
                      <button className={styles.button + " " + styles.white} onClick={() => addItem(1)}>{LAYOUT_TEXT.ADD_TO_DESIGN}</button>

                    </> :
                    <>
                      <span className={styles.description}>No company Logo </span>
                      <button className={styles.button + " " + styles.white} onClick={() => navigateOut(`/company/1/${issuer_id}/profile`)}>+ Update Profile</button>
                    </>
                }
              </div>
            {User?.qr_enabled &&  <div className={styles.card}>
                {
                  qrCode && User?.qr_enabled ?
                    <>
                      {/* <div className={styles.Elementactions}>
                      <div>
                        <button className={styles.button} onClick={() => navigateOut(`/company/1/${issuer_id}/profile`)}>+ Update Logo</button>
                      </div>
                    </div> */}
                      <div className={styles.description}>
                        <img src={qrCode} className={styles.image} />
                      </div>
                      <button className={styles.button + " " + styles.white} onClick={() => addItem(4)}>{LAYOUT_TEXT.ADD_TO_DESIGN}</button>

                    </> :
                    <>
                      <span className={styles.description}>No company Logo </span>
                      <button className={styles.button + " " + styles.white} onClick={() => navigateOut(`/company/1/${issuer_id}/profile`)}>+ Update Profile</button>
                    </>
                }
              </div>}
              <div className={styles.card}>
                {Address ?
                  <>
                    {/* <div className={styles.Elementactions}>
                    <div>
                      <button className={styles.button} onClick={() => navigateOut(`/company/1/${issuer_id}/profile`)}>+ Update Address</button>
                    </div>
                  </div> */}
                    <span className={styles.description}>{Address.split("<br>").join(", ")}</span>
                    <button className={styles.button + " " + styles.white} onClick={() => addItem(2)}>{LAYOUT_TEXT.ADD_TO_DESIGN}</button>
                  </> :
                  <>
                    <span className={styles.description}>No Address </span>
                    <button className={styles.button + " " + styles.white} onClick={() => navigateOut(`/company/1/${issuer_id}/profile`)}>+ Update Profile</button>
                  </>
                }


              </div>
              <div className={styles.card}>
                {Sign.url ?
                  <>
                    <div className={styles.Elementactions}>
                      <div>
                        <label className={styles.button} htmlFor="SignatureUpload">+ Add New</label>
                        <input type="file" id="SignatureUpload" style={{ display: "none" }} className={styles.fileInput} onChange={e => (handleImageUpload(e, 1))} />
                      </div>
                    </div>
                    <div className={styles.description}>
                      <img src={Sign.url} className={styles.image} />
                    </div>
                    <button className={styles.button + " " + styles.white} onClick={() => addItem(3)} >{LAYOUT_TEXT.ADD_TO_DESIGN}</button>
                  </>
                  :
                  <>
                  <label htmlFor="SignatureUpload" className='cursor-pointer'>
                    <div className={styles.description}>
                      <img className={styles.uploadOutlineIcon} alt="" src="/uploadoutline.svg" />
                      Upload Signature
                      <input type="file" id="SignatureUpload" style={{ display: "none" }} className={styles.fileInput} onChange={e => (handleImageUpload(e, 1))} />
                    </div>
                    </label>
                  </>
                }
              </div>
              <div className={styles.card}>
                {background?.url ?
                  <>
                    <div className={styles.Elementactions}>
                      <input className='slider' min='0' max='1' type='range' step="0.01" value={background.opacity} onChange={(e) => handleOpacity(e.target.value)} />
                      {/* <button className={styles.button + " " + styles.white} onClick={() => setBackground({ url: '', opacity: '', file: '' })} style={{marginTop:"15px"}}>{BUTTONS.REMOVE}</button> */}
                    </div>
                    <div className={styles.description}>
                      <img src={background.url} className={styles.image} />
                    </div>
                    <label className={styles.button + " " + styles.white} htmlFor="backgroundUpload">+ Update Cover</label>
                    <input type="file" id="backgroundUpload" accept=".jpg,.jpeg,.png,.pdf" style={{ display: "none" }} className={styles.fileInput} onChange={e => (handleImageUpload(e, 0))} />
                  </>
                  :
                  <>
                  <label htmlFor="backgroundUpload" className='cursor-pointer'>
                    <div className={styles.description}>
                      <img className={styles.uploadOutlineIcon} alt="" src="/uploadoutline.svg" />
                      Upload Background
                      <input type="file" id="backgroundUpload" accept=".jpg,.jpeg,.png,.pdf" style={{ display: "none" }} className={styles.fileInput} onChange={e => (handleImageUpload(e, 0))} />
                    </div>
                    </label>
                  </>

                }
                     {background?.url&& <button className={styles.button + " " + styles.white} onClick={() => {setIsBackgroundRemoved(true);setBackground({ url: '', opacity: 1, file: null })}}>{BUTTONS.REMOVE}</button>}

              </div>

            </div>
            {/* <button className={styles.scrollButton} onClick={() => scrollTray('right')}><Icon icon={chevronRight} size={20} /></button> */}
          </div>
        </div>
        <div className={styles.layoutRow}>
          <div className={styles.controller + " " + styles.backgroundCard}>
            <h2 className='header-title' style={{ fontSize: '1rem', margin: '1rem 0' }}>Edit components</h2>
            {selectedItem.name ?
              (selectedItem?.name == contentType[3] || selectedItem?.name == contentType[5]) ?
                <>
                  <div className={styles.buttonBase} style={{ justifyContent: 'space-between' }} >
                    <h3>{selectedItem.name}</h3>
                    <div className={styles.buttonBase}>
                      {
                        (selectedItem?.id != null && selectedItem?.name != contentType[3]) ?
                          <button onClick={() => removeItem(selectedItem.id)} className={styles.button + " " + styles.white} title="remove">{BUTTONS.REMOVE}</button>
                          :
                          <button className={styles.button + " " + styles.white} disabled style={{ cursor: 'not-allowed' }} title='you cannot remove this'>{BUTTONS.REMOVE}</button>
                      }
                      {/* <button className={styles.tagName} onClick={(e) => validate(e)}>{buttonLoading == 3 ? BUTTONS.VALIDATING : BUTTONS.VALIDATE}</button> */}
                      <div>
                        <span className={styles.tagName} onClick={(e) => { setTagsDropDown(!tagsDropDown) }}><img src='/Tags.svg' />{LAYOUT_TEXT.INSERT_TAGS}</span>
                        {tagsDropDown ? DropDown() : null}
                      </div>
                    </div>

                  </div>
                  <Editor
                  key={selectedItem.id}
                    selectedItem={selectedItem}
                    updatePosition={updatePosition}
                    removeItem={removeItem}
                    editorRef={editorRef}
                  />
                </>
                :
                <>
                  <div className={styles.buttonBase} style={{ justifyContent: 'space-between' }}>
                    <h3>{selectedItem.name}</h3>
                    <button onClick={() => removeItem(selectedItem.id)} className={styles.button + " " + styles.white}>{BUTTONS.REMOVE}</button>
                  </div>
                </>
              :
              <div className={styles.buttonBase} style={{ justifyContent: 'space-between' }}>
                <h3>{LAYOUT_TEXT.EDITOR_HEADING}</h3>
              </div>}
          </div>
          <div className={styles.divider} />
          <div className={styles.layoutPreview}>
            <div className={styles.layoutPagination}>
              <div className={styles.buttonBase}>
                <span onClick={() => setCurrentPage(page - 1)} className={styles.button + " " + styles.white}><Icon icon={chevronLeft} size={14} /></span>
                <h2 className=" header-title">{page}/{totalPage}</h2>
                <span onClick={() => setCurrentPage(page + 1)} className={styles.button + " " + styles.white}><Icon icon={chevronRight} size={14} /></span>
              </div>
              <div>
                <h2 className='header-title' style={{ fontSize: '1rem' }}>Preview</h2>
              </div>
              <div className={styles.buttonBase}>
                <div onClick={addNewPage} className={styles.button + " " + styles.white}>
                  {/* <Icon icon={androidDocument} size={20} /> */}
                  {LAYOUT_TEXT.ADD_MORE_PAGE}</div>
                <div onClick={removePage} className={styles.button + " " + styles.white}>{/* <Icon icon={androidDocument} size={20} /> */}{LAYOUT_TEXT.REMOVE_PAGE}</div>
              </div>
            </div>
            <div className={styles.containerWrapper} ref={sendPdf}>
              <div className={styles.container} ref={parentRef}>
                {items.map((item) => (
                  <DraggableItem
                    key={item.id}
                    content={item}
                    updatePosition={updatePosition}
                    setSelectedItem={setSelectedItemId}
                    isSelected={item.id === selectedItemId}
                    items={items}
                    parentRef={parentRef}
                    contentType={contentType}
                  />
                ))}
              </div>
            <div className={styles.containerBackground} style={{ backgroundImage: `url(${background.url})`, opacity: background.opacity }}></div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default LayoutDocument;